import { Button } from "@newsela/angelou";
import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
} from "@newsela/snitch";

import AIButton from "@/components/AIComponents/AiButton";
import { useExportablesModalContext } from "@/components/AIComponents/ExportablesModal/ExportablesModalContext/useExportablesModalContext";
import { buttonContainerStyles } from "./ExportablesModalFooter.styles";
import { getNextButtonHandler, getPreviousButtonHandler } from "./utils";

const ButtonWithTrackEvent = withTrackEvent(Button);
const AIButtonWithTrackEvent = withTrackEvent(AIButton);

const StudentActions = () => {
  const { selectedExportable, templateList } = useExportablesModalContext();

  const currentTemplateIndex =
    templateList?.findIndex(
      ({ seti_identifier }) =>
        seti_identifier === selectedExportable.seti_identifier,
    ) || 0;
  const isLastTemplate = currentTemplateIndex === templateList.length - 1;

  const actionName = isLastTemplate ? actionNames.save : actionNames.navigate;
  const buttonLabel = isLastTemplate ? "Save" : "Next";
  const description = isLastTemplate
    ? "Save Graphic Organizer submission"
    : "Show next Graphic Organizer";
  const nextButtonQaSelector = isLastTemplate
    ? "save-graphic-organizer-submission"
    : "show-next-graphic-organizer";

  const handleNextButton = getNextButtonHandler();
  const handlePreviousButton = getPreviousButtonHandler();

  return (
    <>
      <ButtonWithTrackEvent
        flavor={Button.flavors.secondary}
        onClick={handlePreviousButton}
        dataProps={{ "data-qa-selector": "show-previous-graphic-organizer" }}
        objectType={objectTypes.generatedTextAsset}
        actionPrefix={actionPrefixes.initiate}
        actionName={actionNames.navigate}
        streamProperties={{ description: "Show previous Graphic Organizer" }}
      >
        Previous
      </ButtonWithTrackEvent>
      <AIButtonWithTrackEvent
        removeIcon
        onClick={handleNextButton}
        __cssFor={buttonContainerStyles}
        dataProps={{ "data-qa-selector": nextButtonQaSelector }}
        objectType={objectTypes.generatedTextAsset}
        actionPrefix={actionPrefixes.initiate}
        actionName={actionName}
        streamProperties={{ description }}
      >
        {buttonLabel}
      </AIButtonWithTrackEvent>
    </>
  );
};

export default StudentActions;
